// extracted by mini-css-extract-plugin
module.exports = {"overlay":"overlay_overlay__NNliy","dark":"overlay_dark__DXezt","white":"overlay_white__ALC_Y","fullScreen":"overlay_fullScreen__gaNDq"};